export const SPOT_EXCHANGES = ['trans', 'timocom', 'teleroute', 'econtainers'] as const

export type ExchangeKey = (typeof SPOT_EXCHANGES)[number]

export type ExchangeAvailability = Record<ExchangeKey, boolean>

export type PartialExchangeAvailability = Partial<ExchangeAvailability>

export type ExchangeMarketSource = 'TRANS' | 'TIMOCOM' | 'TELEROUTE' | 'ECONTAINERS'

export type MarketSource = ExchangeMarketSource | 'SHIPPERS'

export const EXCHANGE_TO_MARKET_SOURCE: Record<ExchangeKey, ExchangeMarketSource> = {
  trans: 'TRANS',
  timocom: 'TIMOCOM',
  teleroute: 'TELEROUTE',
  econtainers: 'ECONTAINERS',
}

// E-containers celowo domyślnie WYŁĄCZONA (dostępność włącza admin per firma) —
// spójnie z backendowym ExchangeAvailability.defaults().
export const DEFAULT_EXCHANGE_AVAILABILITY: ExchangeAvailability = {
  trans: true,
  timocom: true,
  teleroute: true,
  econtainers: false,
}
